import {
    GET_TODAY_TASKS, GET_ALL_MEETING, GET_ACTIVITY_LIST, GET_ACTIVITY_BY_ID, GET_FUNCTIONAL_DESIGNATION, PLAN_TYPE, GET_OPEN_PROSPECTIVE
} from '../types/ActivityType';

const initState = { todayTasks: [], allMeetings: [], allFunctionalDesignations: [], activityList: [], activityById: {},planTypes: [], openProspective:[] };

export const ActivityReducer = (state = initState, action) => {
    switch (action.type) {
        case GET_TODAY_TASKS:
            return {
                ...state,
                todayTasks: !action.error ? action.payload.list : state.todayTasks
            }
        case GET_ALL_MEETING:
            return {
                ...state,
                allMeetings: !action.error ? action.payload.list : state.allMeetings
            }
        case GET_ACTIVITY_LIST:
            return {
                ...state,
                activityList: !action.error ? action.payload.list : state.activityList
            }
        case GET_FUNCTIONAL_DESIGNATION:
            return {
                ...state,
                allFunctionalDesignations: !action.error ? action.payload.list : state.allFunctionalDesignations
            }
        case GET_ACTIVITY_BY_ID:
            return {
                ...state,
                activityById: !action.error ? action.payload.list : state.activityById
            }
        case PLAN_TYPE:
            return {
                ...state,
                planTypes: !action.error ? action.payload : state.planTypes
            }  
        case GET_OPEN_PROSPECTIVE:
                return {
                    ...state,
                    openProspective :!action.error ? action.payload : state.openProspective
            }                   
        default:
            return state;
    }
}